import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";
import { Link, useLocation} from "react-router-dom";
import DropdownItemsDynamic from "./DropdownItemsDynamic";

const MenuItemsDynamic = ({ item, depthLevel, closeMobileMenu }) => {
  const { t } = useTranslation();
  const [dropdown, setDropdown] = useState(false);
  const location = useLocation(); // <--- 1. Detecta la URL actual

  // 2. Este efecto se dispara cada vez que la URL cambia
  useEffect(() => {
    setDropdown(false); 
  }, [location]); 

  
  let ref = useRef();

  useEffect(() => {
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [dropdown]);

  const onMouseEnter = () => {
    if (window.innerWidth > 992) setDropdown(true);
  };

  const onMouseLeave = () => {
    if (window.innerWidth > 992) setDropdown(false);
  };

  // Maneja el clic en el botón que abre submenús
  const handleDropdownToggle = (e) => {
    e.stopPropagation(); // IMPORTANTE: Evita que el clic cierre el menú móvil
    setDropdown((prev) => !prev);
  };

  return (
    <li
      className="menus-items-multi"
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    // Quitamos el onClick de aquí para que no cierre todo al abrir un hijo
    >
      {item.submenu?.length > 0 ? (
        <div>
          <button
            type="button"
            aria-haspopup="menu"
            aria-expanded={dropdown ? "true" : "false"}
            onClick={handleDropdownToggle} // Usamos la nueva función
            className="button-multi"
            style={{ display: "inline-flex" }}
          >
            {t(`${item.i18title}`)}
            {depthLevel > 0 ? <span>&raquo;</span> : <span className="arrow" />}
          </button>
          <DropdownItemsDynamic
            depthLevel={depthLevel}
            submenus={item.submenu}
            dropdown={dropdown}
            closeMobileMenu={closeMobileMenu}
          />
        </div>
      ) : (
        <div> 
    {item && item.path && (
      <Link 
        to={item.path} 
        className="nav-links-multi"
        onClick={() => {
          setDropdown(false); // <--- CIERRA EL DROPDOWN EN DESKTOP
          closeMobileMenu();  // <--- CIERRA EL PANEL EN MOBILE
        }} 
      >
        {t(`${item.i18title}`)}
      </Link>
    )}
  </div>
      )}
    </li>
  );
};

export default MenuItemsDynamic;
